import './css/questions-management.scss';
import './css/question-editor.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { RichTextEditor, AnswersEditor } from '../components';

export const QuestionEditor = function ({
  question: { id, questionIntro, question, explanation, options = [], tag, answer },
  chapters,
  onQuestionEdit,
  onAddAnswer,
  onDeleteLastAnswer,
  onUpdateAnswer,
  onSetCorrectAnswer
}) {
  const elmHeight = 48;
  function expandQuestion (ev) {
    const li = ev.target.parentElement.parentElement;
    li.classList.toggle('question-expanded');
    const height = li.scrollHeight;
    const heightValue = li.offsetHeight;
    if (heightValue > elmHeight) {
      shrinkQuestion(ev);
    } else {
      li.style.height = `${height}px`;
    }
  }
  function shrinkQuestion (ev) {
    const li = ev.target.parentElement.parentElement;
    li.style.overflow = 'hidden';
    li.style.height = `${elmHeight}px`;
  }

  return (
    <div className="module-question-layout" cy="module-question-layout">
      <div
        cy="expand-question"
        className="flex flex-between align-center pointer"
        onClick={expandQuestion}
      >
        <span className="click-disabled">Question {id}</span>
        <FontAwesomeIcon className="chevron-icon click-disabled" icon={faChevronDown} />
      </div>
      {chapters?.length > 0 && (
        <div id="chapter-selection">
          <p cy="select-chapter-title">Select Chapter</p>
          <select
            name="tag"
            style={{ color: `${!tag ? '#656565' : ''}` }}
            defaultValue={tag}
            onChange={({ target: { value, name } }) =>
              onQuestionEdit({
                id,
                value,
                fieldName: name
              })
            }
            cy="select-chapter-select"
          >
            <option disabled value="">
              Please select a chapter
            </option>
            {chapters.map((chapter) => (
              <option key={chapter.id} value={chapter.id}>
                {chapter.title}
              </option>
            ))}
          </select>
        </div>
      )}
      <RichTextEditor
        title={'Context'}
        name={'questionIntro'}
        value={questionIntro}
        questionId={id}
        onChange={onQuestionEdit}
        large
        optional
      />
      <RichTextEditor
        title={'Question'}
        name={'question'}
        value={question}
        questionId={id}
        onChange={onQuestionEdit}
      />
      <AnswersEditor
        answers={options}
        correctAnswer={answer}
        questionId={id}
        onAddAnswer={onAddAnswer}
        onDeleteLastAnswer={onDeleteLastAnswer}
        onUpdateAnswer={onUpdateAnswer}
        onSetCorrectAnswer={onSetCorrectAnswer}
      />
      <RichTextEditor
        title={'Answer explanation'}
        name={'explanation'}
        value={explanation}
        questionId={id}
        onChange={onQuestionEdit}
        large
      />
    </div>
  );
};
